import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { IStore } from '../../reducers'
import closeModal from '../../actions/Modals/closeModal'
import getModals from '../../reducers/modals/selectors/getModals'
import ModalContainer, {
  IModalContainer,
  IModalContainerDispatch,
} from './ModalContainer'

const mapStateToProps = (state: IStore): IModalContainer => ({
  modals: getModals(state),
})

const mapDispatchToProps = (dispatch: Dispatch): IModalContainerDispatch => ({
  closeModal: (id: string) => dispatch(closeModal(id)),
})

export default connect<IModalContainer, IModalContainerDispatch, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(ModalContainer)
